// extracted by mini-css-extract-plugin
module.exports = {"container":"categorizerHeadingRowGroup__container___1w28P","separated-rows":"categorizerHeadingRowGroup__separated-rows___1eLw3"};